import { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import toast, { Toaster } from "react-hot-toast";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  getStageListAction,
  resetClientDirectoryError,
  resetClientDirectoryFetching,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetLeadStageList,
  resetLeadStageTotal,
  updateLeadStageAction,
} from "../../../redux/clientDirectory";
import { connect } from "react-redux";
import {
  GetCityListPayloadType,
  StageDetailsType,
  StageInfoPayloadType,
} from "../../../commonTypes/clientDirectoryTypes";
import Tableheader from "../../../components/commons/Table/TableHeader";
import { STAGE_THRESHOLD_HEADERS } from "../../../constant/tableHeadersConstants/LeadDirectoryConstants/leadDirectoryListTableHeaders";
import LeadThresholdTableData from "../../../components/LeadModule/LeadStageThresholdMaster/LeadThresholdTableData";
import StageThresholdModal from "../../../components/LeadModule/LeadStageThresholdMaster/StageThresholdModal";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../../constant/colors";
import { SearchIcon } from "../../../components/Icon";
import useDebounce from "../../../customHooks/useDebounce";

type AppProps = {
  token: null | string;
  history: any;
  fetching: boolean;
  statusCode: number | null;
  message: string | null;
  success: number | null;
  error: null | string;
  leadStageData: StageDetailsType[];
  leadStageCount: number;
  dispatchResetSession: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetError: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetFetching: () => void;
  dispatchLeadStageData: (data: GetCityListPayloadType) => void;
  dispatchResetLeadStageData: () => void;
  dispatchResetLeadStageCount: () => void;
  dispatchEditLeadStageData: (data: StageInfoPayloadType) => void;
};
const LeadModuleStageThresholdMaster = ({
  fetching,
  message,
  history,
  success,
  error,
  token,
  statusCode,
  leadStageData,
  leadStageCount,
  dispatchResetFetching,
  dispatchResetSession,
  dispatchResetSuccess,
  dispatchResetError,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchLeadStageData,
  dispatchResetLeadStageData,
  dispatchResetLeadStageCount,
  dispatchEditLeadStageData,
}: AppProps) => {
  const [stageModal, setStageModal] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>([]);
  const [searchData, setSearchData] = useState("");
  const [isApiCall, setIsApiCall] = useState(false);

  const backColor = (name: string) => {
    const lowerCaseName = name.toLowerCase();

    let backgroundColor;
    let fontColor;

    if (lowerCaseName.startsWith("1") || lowerCaseName.startsWith("1a")) {
      backgroundColor = STAGE_COLOR_CODES[0];
      fontColor = FONT_COL_CODES[0];
    } else if (
      lowerCaseName.startsWith("2a") ||
      lowerCaseName.startsWith("2b") ||
      lowerCaseName.startsWith("2bii") ||
      lowerCaseName.startsWith("2biii") ||
      lowerCaseName.startsWith("2biv") ||
      lowerCaseName.startsWith("2bv") ||
      lowerCaseName.startsWith("2bvi")
    ) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (
      lowerCaseName.startsWith("2c") ||
      lowerCaseName.startsWith("2d")
    ) {
      backgroundColor = STAGE_COLOR_CODES[2];
      fontColor = FONT_COL_CODES[2];
    } else if (
      lowerCaseName.startsWith("3a") ||
      lowerCaseName.startsWith("3b")
    ) {
      backgroundColor = STAGE_COLOR_CODES[3];
      fontColor = FONT_COL_CODES[3];
    } else if (
      lowerCaseName.startsWith("4a") ||
      lowerCaseName.startsWith("4b") ||
      lowerCaseName.startsWith("5")
    ) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (
      lowerCaseName.startsWith("6a") ||
      lowerCaseName.startsWith("6b") ||
      lowerCaseName.startsWith("6c") ||
      lowerCaseName.startsWith("6d") ||
      lowerCaseName.startsWith("6e")
    ) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else {
      backgroundColor = STAGE_COLOR_CODES[6];
      fontColor = FONT_COL_CODES[6];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };
  const styleColor = (name: string) => {
    const { backgroundColor, fontColor } = backColor(name);

    return {
      marginTop: "10px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
      width: "fit-content",
    };
  };

  const blank = () => {
    return {};
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetSuccess();
    dispatchResetError();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetFetching();
    dispatchResetLeadStageData();
    dispatchResetLeadStageCount();

    if (token) {
      dispatchLeadStageData({ token });
      setIsApiCall(true);
    }
  }, []);

  const handleEditData = (data: any) => {
    setEditData(data);
    setStageModal((prev: boolean) => !prev);
  };

  const handleSubmit = (data: StageDetailsType) => {
    let finalData: StageInfoPayloadType = {
      token,
      stageId: data?._id,
      stageName: data?.stage_name,
      thresholdDay: !!data?.thresholdDay ? +data?.thresholdDay : 0,
      uniqueId: data?.unique_id
    };
    dispatchEditLeadStageData(finalData);
    setStageModal((prev: boolean) => !prev);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
    } else {
      if (
        success === 1 &&
        message === "Lead stage has been updated successfully!"
      ) {
        toast.success("Lead stage has been updated successfully!", {
          duration: 2000,
        });
        if (token) {
          let finalData = {
            token,
            searchTerm: searchData,
          };
          dispatchLeadStageData(finalData);
        }
        dispatchResetMessage();
        dispatchResetSuccess();
      }
    }

    return false;
  };

  const fetchNewData = (searchData: string) => {
    dispatchResetSuccess();
    dispatchResetError();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetFetching();
    dispatchResetLeadStageData();
    dispatchResetLeadStageCount();

    if (token) {
      let finalData = {
        token,
        searchTerm: searchData,
      };
      dispatchLeadStageData(finalData);
    }
  };

  useDebounce(
    () => {
      if (isApiCall) {
        if (searchData) {
          fetchNewData(searchData);
        } else {
          dispatchResetSuccess();
          dispatchResetError();
          dispatchResetMessage();
          dispatchResetStatusCode();
          dispatchResetFetching();
          dispatchResetLeadStageData();
          dispatchResetLeadStageCount();

          if (token) {
            let finalData = {
              token,
              searchTerm: searchData,
            };
            dispatchLeadStageData(finalData);
          }
        }
      }
    },
    500,
    [searchData]
  );

  const handleSearch = (e: any) => {
    setSearchData(e?.target?.value);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader title="Stage Threshold Master" />
        </div>

        <div className="col-md-12 ">
          <div className="jobs-card">
            <div className="header">
              <div className="left-header">
                <div>
                  <div className="heading">Stage Threshold Master List</div>

                  {!fetching && (
                    <div
                      className="sub-heading"
                      style={{ marginTop: "-22px" }}
                    >{`Total  ${
                      leadStageCount ? leadStageCount : 0
                    } entries found`}</div>
                  )}
                </div>
              </div>
              <div className="right-header">
                <div className="col-md-9 position-relative ">
                  <span
                    style={{ position: "absolute", top: "8px", left: "25px" }}
                  >
                    <SearchIcon />
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search..."
                    onChange={(e: any) => handleSearch(e)}
                    style={{ paddingLeft: "35px" }}
                    value={searchData}
                  />
                </div>
              </div>
            </div>
            <div className="new-table-style">
              {fetching ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : leadStageData?.length > 0 ? (
                <table className="table table-bordered thead-light">
                  <thead className="text-start">
                    <Tableheader tableHeader={STAGE_THRESHOLD_HEADERS} />
                  </thead>
                  <tbody>
                    <LeadThresholdTableData
                      tableHeader={STAGE_THRESHOLD_HEADERS}
                      data={leadStageData}
                      handleEditData={handleEditData}
                      styleColor={styleColor}
                      blank={blank}
                    />
                  </tbody>
                </table>
              ) : (
                fetching === false &&
                leadStageData?.length === 0 && (
                  <div className="mt-5 pb-5">
                    <EmptyListPage
                      title="No Lead List Found!"
                      imageWidth="30%"
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        {
          <StageThresholdModal
            editData={editData}
            modal={stageModal}
            setModal={setStageModal}
            styleColor={styleColor}
            handleSubmit={handleSubmit}
          />
        }
        {fetching && <Loader />}

        <Toaster />
        {handleErrorModal()}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientDirectory.fetching,
  leadFetching: state.clientDirectory.leadFetching,
  error: state.clientDirectory.error,
  statusCode: state.clientDirectory.statusCode,
  success: state.clientDirectory.success,
  message: state.clientDirectory.message,
  leadStageData: state.clientDirectory.leadStageList,
  leadStageCount: state.clientDirectory.leadStageTotal,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetClientDirectorySuccess()),
  dispatchResetError: () => dispatch(resetClientDirectoryError()),
  dispatchResetMessage: () => dispatch(resetClientDirectoryMessage()),
  dispatchResetStatusCode: () => dispatch(resetClientDirectoryStatusCode()),
  dispatchResetFetching: () => dispatch(resetClientDirectoryFetching()),
  dispatchLeadStageData: (data: GetCityListPayloadType) =>
    dispatch(getStageListAction(data)),
  dispatchEditLeadStageData: (data: StageInfoPayloadType) =>
    dispatch(updateLeadStageAction(data)),
  dispatchResetLeadStageData: () => dispatch(resetLeadStageList()),
  dispatchResetLeadStageCount: () => dispatch(resetLeadStageTotal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadModuleStageThresholdMaster);
